function transformPath(path: string) {
    if (path.endsWith('/')) {
        return path.slice(0, -1);
    }
    return path;
}

export function filterMenu(pageRouter = {}, allRouter) {
    const accessMenu = {};
    const newRoutes: any[] = [];
    for (const item of allRouter) {
        const path = transformPath(`/league/admin${item.path}`);
        if (!pageRouter[path]) {
            continue; // 说明当前一级菜单无权限
        }

        const accessMenuChildren = {};
        const newRoutesChildren: any[] = [];
        for (const subItem of item.children || []) {
            const isNeedItemPath =
                !subItem.path.startsWith('mew') &&
                !subItem.path.startsWith('bellossom') &&
                !subItem.path.startsWith('beedrill'); // 特殊化子应用处理
            const childrenPath = `/league/admin${isNeedItemPath ? item.path : '/'}${subItem.path}`;
            if (!pageRouter[childrenPath] && !subItem.permit) {
                // 判断有无页面权限
                continue;
            }
            newRoutesChildren.push(subItem);
            accessMenuChildren[subItem.name] = {
                show: typeof subItem.show === 'undefined' ? true : subItem.show,
                name: subItem?.meta?.text,
                path: `${isNeedItemPath ? item.path : '/'}${subItem.path}`,
            };
        }
        accessMenu[item.name] = {
            name: item.meta.text,
            icon: item.meta.icon,
            iconActive: item.meta.iconActive,
            show: true,
            children: accessMenuChildren,
            path: item.path,
        };
        newRoutes.push({
            ...item,
            children: newRoutesChildren,
        });
    }
    return {
        accessMenu,
        newRoutes,
    };
}

interface Resources {
    resourceId: number;
    resourceKey: string;
    resourceName: string;
    resourceType: 1 | 2; // 1-按钮 2-页面
}

// 将用户权限资源打平，并处理为我们需要的page、btn格式
export function transformPermit(userResources: Resources[] = []) {
    const page: { [key: string]: Resources } = {};
    const btn: { [key: string]: Resources } = {};
    userResources.forEach(item => {
        if (item.resourceType === 1) {
            btn[item.resourceKey] = item;
        } else if (item.resourceType === 2) {
            page[item.resourceKey] = item;
        }
    });
    return {
        page,
        btn,
    };
}
